import React from 'react'
import {Container, Table} from "react-bootstrap"
import Questions_Table from '../../utilities/tableQuestionnaire/questionnaire_custom_answers'
import questions from './data.json'
import Title from "../../utilities/other/title"

class PDQ extends React.Component{
    constructor(props){
        super(props)
        this.state ={score:0}
    }
    onChange = async  (event) =>{
        const {name,value} = event.target
        await this.setState((prevState)=>({
            ...prevState,
            [name]:`${value}`
        }))
        this.props.handler('pdq',this.state )
       
    }
    Scoring = async (val)=> {
       
        
        if (!isNaN(val)){
             await this.setState((prevState) => 
                         ({
                             ...prevState,
                             score:prevState.score + (val)
 
                         })
                         
             )
         }
         
     }
    componentDidUpdate(prevProps,prevState){
        // if (prevState != this.state){
        //     this.props.handler('pdq',this.state )
        // }
    }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    render(){
       
        return(
            <Container>
                <Title>Parkinson’s Disease Quality of Life Questionnaire (PDQ-8) </Title>
                <Questions_Table title= 'fab' score={true} scoreFunc={this.Scoring} questions={questions} data={this.props.data} disabled={this.props.disabled} answers={questions} handler={this.onChange} fieldName={'fab'}/>
                <Table>
                    <tbody>
                        <tr>
                            <th>Score:</th>
                            <th><p className={'score'}>{this.state.score}</p></th>
                        </tr>
                        </tbody>
                </Table>
            </Container>
        )
    }
}
PDQ.defaultProps ={
    data:null,
    disabled:false
}

export default PDQ